<div *ngIf="spinnerIsShown"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
<div class="modal-content border-0">
    <div class="invisible-scrollbar" style=" overflow: scroll; min-height: 50vh; max-height:fit-content; ">
        <div class="modal-body" style="padding-bottom: 0px;">

            <div class="row g-3">

                <div class="position-absolute icon" style="margin-top: 42px !important;">
                    <div class="d-inline-block">
                        <div class="avatar-lg p-1">
                            <div class="avatar-title bg-light rounded-circle">
                                <img src="{{getDocumentImageUrl(myfile)}}" id="companylogo-img"
                                    class="avatar-md rounded-circle" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">

                    <div class="px-1 pt-1">
                        <div class="modal-team-cover position-relative mb-0 mt-n4 mx-n4 rounded-top overflow-hidden">

                            <strong>
                                <img src="{{getDocumentImageUrl(myfile)}}" alt="" id="modal-cover-img">

                                <div class="d-flex position-absolute start-0 end-0 top-0 p-3">

                                    <div class="flex-grow-1"
                                        style="color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;">
                                        <div style="font-size: 28px;">
                                            {{requisition.type || nameTrim(model.myfile?.name)}}
                                        </div>
                                        <div style="font-size: 20px; ">
                                            <span *ngIf="requisition.number else newReq">
                                                <span>Requisition</span> {{requisition.number}}
                                            </span>
                                            <ng-template #newReq>
                                                <span> New Requisition</span>
                                            </ng-template>
                                        </div>
                                        <div style="font-size: 1rem; color: #f59e0b;"> <span>Price: </span>
                                            {{priceTotal|
                                            currency}}</div>
                                        <div *ngIf="billableUser && requisitionStatus != 0">
                                            <div class="avatar-group justify-content-center">
                                                <h5 class="align-content-center fs-13 me-2"
                                                    style="margin-top: 0.15rem; color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;">
                                                    Bill to:</h5>

                                                <a class=" me-2"
                                                    style="cursor: default !important; color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;"
                                                    placement="top">
                                                    <img [src]="profilePhotoPNGTransform(billableUser)"
                                                        class=" avatar-xs rounded-circle me-1"
                                                        style="height: 24px !important; width: 24px !important">
                                                    {{billableUser.fullName}}
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="requisition.assignees && requisition.assignees.length > 0">

                                            <div class="avatar-group justify-content-center">

                                                <h5 class="align-content-center fs-13 me-2"
                                                    style="margin-top: 0.15rem; color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;">
                                                    Assignees:</h5>

                                                <a *ngFor="let assignee of requisition.assignees" class=" me-2"
                                                    style="cursor: default !important; color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;"
                                                    placement="top">
                                                    <img [src]="profilePhotoPNGTransform(assignee)"
                                                        class=" avatar-xs rounded-circle me-1"
                                                        style="height: 24px !important; width: 24px !important">
                                                    {{assignee.fullName}}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-0 ">

                                        <div class="d-flex gap-3 align-items-center">

                                            <button type="button" class="btn-close"
                                                style="background-color: rgba(0, 0, 0, 0.1)" (click)="close()"
                                                id="close-jobListModal" data-bs-dismiss="modal" aria-label="Close">
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </strong>
                        </div>
                    </div>
                    <div class="modal-body p-0" style="position: absolute; width: calc(100% + 2rem); left: -20px;">
                        <div class="step-arrow-nav">
                            <ul ngbNav [(activeId)]="requisitionStatus" class="nav nav-pills custom-nav nav-justified"
                                role="tablist">
                                <li [ngbNavItem]="0" class="nav-item" [disabled]="true">
                                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                                        Draft
                                    </a>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </li>
                                <li *ngIf="requisition.isExplicitClientSignatureRequired" [ngbNavItem]="5"
                                    class="nav-item" [disabled]="true">
                                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                                        Signature Pending
                                    </a>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </li>
                                <li [ngbNavItem]="1" class="nav-item" [disabled]="true">
                                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                                        Submitted
                                    </a>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </li>

                                <li [ngbNavItem]="2" class="nav-item" [disabled]="true">
                                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                                        Processing
                                    </a>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </li>
                                <li [ngbNavItem]="3" class="nav-item" [disabled]="true">
                                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                                        Completed
                                    </a>
                                    <ng-template ngbNavContent>
                                    </ng-template>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
                        style="margin-right:-1.25rem; margin-left:-1.25rem; margin-top: 2.25rem;"
                        class="nav nav-tabs-custom  card-header-tabs border-bottom-0center justify-content-center mb-4"
                        role="tablist">
                        <li [ngbNavItem]="1" class="nav-item">
                            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                <i class="fas fa-home"></i>
                                <div i18n="@@">Details </div>
                            </a>
                            <ng-template ngbNavContent>
                                <ng-container *ngTemplateOutlet="details"></ng-container>
                                <div *ngIf="requisition.id && !submitted" class="mb-3">
                                    <div class="card-header align-items-center d-flex">
                                        <h4 class="card-title mb-0 flex-grow-1" i18n="@@">eDocument(s)</h4>
                                    </div>
                                </div>
                                <ng-container *ngTemplateOutlet="documentsList"></ng-container>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2" class="nav-item" *ngIf="securityRoleIsUserGuest == false">
                            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                <i class="far fa-user"></i>
                                <div i18n="@@">Attachments</div>
                            </a>
                            <ng-template ngbNavContent>
                                <span *ngIf="requisition.id != undefined">
                                    <app-file-management [entityId]="requisition.id" [entityTypeId]="entityTypeId"
                                        [entityName]="requisition.number"></app-file-management>
                                </span>
                                <span *ngIf="requisition.id == undefined">
                                    <app-file-management [entityName]="'New Requisition'"
                                        [filesIdsToAdd]="model.fileUpload.fileIdsToAdd"
                                        (filesIdsToAddChanged)="onNewModalEntityFileIdsAdded(model,$event)"
                                        [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
                                </span>
                            </ng-template>
                        </li>
                        <li *ngIf="requisition.id" [ngbNavItem]="3" class="nav-item">
                            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                <i class="far fa-user"></i>
                                <div i18n="@@">Recent Activity</div>
                            </a>
                            <ng-template ngbNavContent>
                                <div>
                                    <app-timeline-note-list [displayFilterType]="true" [ownerType]="ownerType"
                                        [display]="2" [timelineOwnerId]="entityId"
                                        [timelineClientId]="clientId"></app-timeline-note-list>
                                </div>
                            </ng-template>
                        </li>
                        <li *ngIf="requisition.id && requisition.status && requisition.status >=2 && securityPermissionRequisitionViewPayment"
                            [ngbNavItem]="4" class="nav-item">
                            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                <i class="far fa-user"></i>
                                <div i18n="@@">Payment History</div>
                            </a>
                            <ng-template ngbNavContent>
                                <app-payment-list [sourceId]="requisition.id"></app-payment-list>
                            </ng-template>
                        </li>
                    </ul>
                    <div class="tab-model">
                        <div [ngbNavOutlet]="customNav"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="padding: 1.25rem; padding-top: 0;">
        <div *ngIf="!requisition.id && securityPermissionRequisitionCreate"
            style="display: flex; justify-content: end;">
            <button *ngIf="this.myfile.type != enumTemplateDocumentType.Retainer else elseRetainerTitle "
                class="btn btn-primary btn-label right" (click)="save()" [disabled]="spinnerIsShown"><i
                    class="ri-shopping-cart-2-line label-icon align-middle fs-16 ms-2"></i>
                <span i18n="@@">Add to Cart</span>
            </button>
            <ng-template #elseRetainerTitle>
                <button class="btn btn-primary" (click)="save()" [disabled]="spinnerIsShown">
                    <span i18n="@@">Create</span>
                </button>
            </ng-template>
        </div>

        <div class="gap-2" style="display: flex; justify-content: end;"
            *ngIf="requisition.id && requisitionStatus != enumRequisitionStatus.Completed && requisitionStatus != enumRequisitionStatus.Incompleted "
            ngbDropdown>
            <ul #actionList aria-labelledby="dropdownMenuLink1" ngbDropdownMenu>
                <li class="p-2 "
                    *ngIf="securityPermissionRequisitionCreateCheque && requisitionStatus == enumRequisitionStatus.Processing">
                    <button style="width: 100%;" (click)="cheque()" class="btn btn-soft-primary" i18n="@@"> Create
                        Cheque</button>
                </li>
                <li class="p-2 "
                    *ngIf="securityPermissionRequisitionCreateInvoice && requisitionStatus == enumRequisitionStatus.Processing">
                    <button style="width: 100%;" (click)="invoice()" class="btn btn-soft-primary" i18n="@@"> Create
                        Invoice</button>
                </li>
                <li class="p-2 "
                    *ngIf="securityPermissionRequisitionIncomplete && requisitionStatus == enumRequisitionStatus.Processing">
                    <button style="width: 100%;" (click)="incomplete()" class="btn btn-soft-danger" i18n="@@">
                        Incomplete</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionRequisitionComplete && requisitionStatus == enumRequisitionStatus.Processing">
                    <button style="width: 100%;" (click)="complete()" class="btn btn-soft-success"
                        i18n="@@">Complete</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionRequisitionUpdate && requisition.id && requisitionStatus == enumRequisitionStatus.Draft">
                    <button style="width: 100%;" (click)="save()" class="btn btn-soft-primary" i18n="@@">Update</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionUserReadLimitedToScope && requisitionStatus != enumRequisitionStatus.Draft">
                    <button style="width: 100%;" (click)="editAssignees()" class="btn btn-soft-secondary"
                        i18n="@@">Assignee Management</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionRequisitionReject && requisitionStatus == enumRequisitionStatus.Submitted">
                    <button style="width: 100%;" (click)="reject()" class="btn btn-soft-danger"
                        i18n="@@">Reject</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionRequisitionProcess && requisitionStatus == enumRequisitionStatus.Submitted">
                    <button style="width: 100%;" (click)="accept()" class="btn btn-soft-success"
                        i18n="@@">Process</button>
                </li>
                <li class="p-2"
                    *ngIf="securityPermissionRequisitionSubmit && requisition.id && requisitionStatus == enumRequisitionStatus.SignaturePending  && requisition.isExplicitClientSignatureRequired == true">
                    <button style="width: 100%;" (click)="sentRequestSignature()" class="btn btn-soft-primary"
                        i18n="@@">Resend Signature Request </button>
                </li>
            </ul>


            <button *ngIf="actionList.getElementsByTagName('li').length > 0" type="button" id="dropdownMenuLink1"
                data-bs-toggle="dropdown" aria-expanded="false"
                class="btn btn-soft-info arrow-none display: flex; justify-content: end;" ngbDropdownToggle>
                <span i18n="@@"> Actions</span> <i class="ri-more-2-fill align-bottom"></i>
            </button>

            <button
                *ngIf="securityPermissionRequisitionSubmit && requisition.id && requisitionStatus == enumRequisitionStatus.Draft && this.myfile.type != enumTemplateDocumentType.Retainer && requisition.isExplicitClientSignatureRequired != true"
                class="btn btn-primary btn-label right" (click)="purchase()"><i
                    class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                <span i18n="@@"> Submit</span>
            </button>

            <button
                *ngIf="securityPermissionRequisitionSubmit && requisition.id && requisitionStatus == enumRequisitionStatus.Draft && this.myfile.type != enumTemplateDocumentType.Retainer && requisition.isExplicitClientSignatureRequired == true"
                class="btn btn-primary btn-label right" (click)="requisitionRequestSignature()"><i
                    class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                <span i18n="@@"> Request Signature</span>
            </button>

            <button
                *ngIf="securityPermissionRequisitionSubmit && requisition.id && requisitionStatus == enumRequisitionStatus.Draft && this.myfile.type == enumTemplateDocumentType.Retainer"
                class="btn btn-primary btn-label right" (click)="submitRetainer()"><i
                    class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                <span i18n="@@"> Complete</span>
            </button>
        </div>
    </div>
</div>

<ng-template #details>
    <div class="row ">

        <div class="col-lg-6 mb-3">
            <label for="jobtitle-field" class="form-label" i18n="@@Modal_Requisition_Text_SelectClient">Client</label>
            <div class="form-control" style="padding: 0%;"
                [ngClass]="{'is-invalid': !requisition.client.id &&  submitted == true  }">
                <app-client-list-dropdown
                    [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                    [(referenceModel)]="requisition.client"
                    (referenceModelChange)="clientChosen($event, requisition.client)"></app-client-list-dropdown>
            </div>
            <div *ngIf="!requisition.client.id && submitted == true" class='invalidInputTextMessage'>
                <div i18n="@@Modal_Requisition_Error_ClientRequired">
                    Client Selection Required
                </div>
            </div>
        </div>
        <div class="col-lg-6 mb-3">
            <label for="experience-field" class="form-label" i18n="">Contact</label>
            <div class="form-control" style="padding: 0%;"
                [ngClass]="{'is-invalid': !requisition.account.id &&  submitted == true  }">
                <app-contact-list-dropdown
                    [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                    [display]=3 [(referenceModel)]="requisition.account"
                    (referenceModelChange)="contactChosen($event, requisition.account)"></app-contact-list-dropdown>
            </div>
            <div *ngIf="!requisition.account.id &&   submitted == true" class='invalidInputTextMessage'>
                <!-- this is the style of form-invalid -->
                <div i18n="@@Modal_Requisition_Error_ContactRequired">
                    Contact Selection Required
                </div>
            </div>
        </div>
    </div>


    <div class="row ">
        <div class="mb-3"
            [ngClass]="{'col-lg-4': (securityRoleIsUserGuest == false), 'col-lg-6': (securityRoleIsUserGuest == true)}">

            <label for="job_type-field" class="form-label" i18n="@@Modal_Requisition_Text_SelectMatter">Matter
                Number</label>

            <input
                [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                class="form-control" type="text" placeholder="Enter Matter Number" i18n-placeholder="@@"
                [(ngModel)]="requisition.matterNumber" (keypress)="contactEdited = true" />
        </div>
        <div class="mb-3"
            [ngClass]="{'col-lg-4': (securityRoleIsUserGuest == false), 'col-lg-6': (securityRoleIsUserGuest == true)}">
            <label for="experience-field" class="form-label" i18n="@@Modal_Requisition_Text_SelectDoL">Date of
                Loss</label>
            <div class=" input-group d-flex form-control" style="padding: 0%; "
                [ngClass]="{'is-invalid': ((dateOfLossVal.invalid ) && ((dateOfLossVal.dirty || dateOfLossVal.touched) || submitted == true) && (spinnerIsShown==false))  }">
                <input class=" flex-grow-1 form-control " #dateOfLossVal="ngModel" required style="border-width: 0;"
                    [pattern]=datePattern
                    [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                    type="text" [dropSpecialCharacters]="false" [(ngModel)]="requisition.dateOfLoss"
                    placeholder="DD/MM/YYYY" mask="00/00/0000" i18n-placeholder="@@"
                    (keypress)="contactEdited = true; " />
                <span class=" input-group-text ri-calendar-2-line " style="  align-self: center; border-width: 0;"
                    [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                    type="text" mwlFlatpickr [disableMobile]="true" [(ngModel)]="requisition.dateOfLoss"
                    [dateFormat]="'d/m/Y'" [ngStyle]="{'cursor': (disableEditing) ? 'default': 'pointer'} "></span>
            </div>
            <div *ngIf="((dateOfLossVal.invalid ) && ((dateOfLossVal.dirty || dateOfLossVal.touched) || submitted == true) && (spinnerIsShown==false))"
                class='invalidInputTextMessage'>
                <div *ngIf="dateOfLossVal.errors?.['required'] else elseDoLInvalid">
                    <div i18n="@@">Date of Loss Required </div>
                </div>
                <ng-template #elseDoLInvalid>
                    <div *ngIf="(dateOfLossVal.invalid )">
                        <div i18n="@@">Date of Loss Invalid</div>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="col-lg-2 mb-3  align-items-center" *ngIf="securityRoleIsUserGuest == false">
            <span class="">
                <label for="experience-field" class="form-label" i18n="@@"> Is Explicit Client Signature
                    Required</label>
                <div class="form-check form-switch">
                    <input
                        [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                        class="form-check-input" type="checkbox" style="cursor:pointer"
                        value="requisition.isExplicitClientSignatureRequired"
                        [(ngModel)]="requisition.isExplicitClientSignatureRequired">
                </div>
            </span>
     
        </div>
        <div class="col-lg-2 mb-3  align-items-center" *ngIf="securityRoleIsUserGuest == false">
            <span class="">
                <label for="experience-field" class="form-label" i18n="@@"> Is Invoice Approval Required</label>
                <div class="form-check form-switch">
                    <input
                        [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                        class="form-check-input" type="checkbox" style="cursor:pointer"
                        value="requisition.requiresInvoiceApproval"
                        [(ngModel)]="requisition.requiresInvoiceApproval">
                </div>
            </span>

        </div>
    </div>

    <div class="mt-1 mb-3" *ngFor="let groupList of myfileCustomFieldsGroups; let groupIndex = index;"
        id="i_{{groupIndex}}">
        <ngb-accordion #pageAccordion="ngbAccordion" *ngIf="groupList.group[0]" class="accordion" role="tablist"
            activeIds="static-{{activeIdIndex}}" aria-multiselectable="false" (click)=updateActiveIDIndex(groupIndex)>


            <ngb-panel id="static-{{groupIndex}}" class="accordion-item">

                <ng-template ngbPanelTitle>
                    <a class="accordion-header" href="javascript:void(0);">

                        <div class="d-flex position-relative show" style="  z-index: 2;">
                            <h6 class="fs-14 mb-1">
                                {{groupList.groupName}}
                            </h6>
                        </div>
                    </a>
                </ng-template>

                <ng-template ngbPanelContent>

                    <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;">
                            <div *ngFor="let subgroups of groupList.subgroups; let subgroupsIndex = index"
                                style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

                                <ngb-accordion *ngIf="subgroups.group[0]" class="accordion" role="tablist"
                                    #acc="ngbAccordion" activeIds="static-1" aria-multiselectable="false">
                                    <ngb-panel id="static-1" class="accordion-item mb-1">

                                        <ng-template *ngIf="!subgroups.subGroupName" ngbPanelHeader>
                                            <!-- This empty Template controls the default subgroup not having a header in the accordian -->
                                        </ng-template>
                                        <ng-template ngbPanelTitle>
                                            <a data-bs-toggle="collapse" href="javascript:void(0);"
                                                aria-controls="collapseOne">
                                                <div class="d-flex position-relative show" style="  z-index: 3;">

                                                    <h6 class="fs-12 mb-1">
                                                        {{subgroups.subGroupName}}
                                                    </h6>

                                                </div>
                                            </a>
                                        </ng-template>
                                        <ng-template ngbPanelContent class="show">
                                            <div class="show">
                                                <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="row flex pb-3">
                                                        <div class="col-lg-4 mt-3"
                                                            *ngFor="let data of subgroups.group; let myfileIndex = index">

                                                            <label for="job_type-field" class="form-label"
                                                                style="color: var(--vz-accordion-color)">{{data.caption}}</label>

                                                            <div *ngIf="data.dataType == 2 else elseDropdown">
                                                                <div class=" input-group d-flex form-control"
                                                                    style="padding: 0%;">
                                                                    <input class=" flex-grow-1 form-control"
                                                                        #iValue="ngModel" required
                                                                        style="border-width: 0;" [pattern]=datePattern
                                                                        [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                                                                        class="form-control" type="text"
                                                                        [dropSpecialCharacters]="false"
                                                                        [(ngModel)]="data.value"
                                                                        placeholder="DD/MM/YYYY" mask="00/00/0000"
                                                                        i18n-placeholder="@@"
                                                                        (keypress)="contactEdited = true" />
                                                                    <span class=" input-group-text ri-calendar-2-line "
                                                                        style="border-width: 0; align-self: center;"
                                                                        [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                                                                        type="text" mwlFlatpickr [disableMobile]="true"
                                                                        [(ngModel)]="data.value"
                                                                        [dateFormat]="'d/m/Y'"></span>
                                                                </div>
                                                            </div>

                                                            <ng-template #elseDropdown>
                                                                <div *ngIf="data.dataType == 19 else elseBool">
                                                                    <app-ng-select-layout
                                                                        [placeHolderText]="'Select Value'"
                                                                        [disableInput]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                                                                        [(model)]="data.value"
                                                                        [items]="data.keyValues"></app-ng-select-layout>
                                                                </div>

                                                            </ng-template>
                                                            <ng-template #elseBool>
                                                                <div *ngIf="data.dataType == 17 else elseBasicInput">

                                                                    <div class="form-check form-switch">
                                                                        <input
                                                                            [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                                                                            class="form-check-input" type="checkbox"
                                                                            [checked]="getMyfileBoolValue(data.value)"
                                                                            (change)="setMyfileBoolValue(data.value,groupIndex,subgroupsIndex,myfileIndex)" />
                                                                    </div>

                                                                </div>
                                                            </ng-template>
                                                            <ng-template #elseBasicInput>
                                                                <input
                                                                    [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                                                                    class="form-control" type="text"
                                                                    placeholder="Enter {{data.caption}}"
                                                                    i18n-placeholder="@@" [(ngModel)]="data.value"
                                                                    (keypress)="contactEdited = true" />
                                                            </ng-template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>
                    </div>

                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>

    <div *ngIf="this.myfile.type != enumTemplateDocumentType.Retainer && (requisition.additionalInfo || requisition.status == 0)"
        class="row ">
        <div class="col-lg-12 mb-3">

            <label for="job_type-field" class="form-label" i18n="@@">Additional Information</label>

            <textarea style="max-height: 200px; overflow-y: auto;
                word-wrap:break-word"
                [disabled]="disableEditing || !((newRequisition === false && securityPermissionRequisitionUpdate) || (newRequisition === true && securityPermissionRequisitionCreate))"
                class="form-control" type="text"
                placeholder="Enter any Additional Information you may require from the contact" i18n-placeholder="@@"
                [(ngModel)]="requisition.additionalInfo" (keypress)="contactEdited = true"> </textarea>
        </div>
    </div>

</ng-template>

<ng-template #documentsList>

    <div *ngIf="requisition.id" class="card" id="contactList"
        style="box-shadow:none; position: relative; padding-bottom: 0px;">

        <div class="card-body bg-soft-light " style="padding-bottom: 0px; border-bottom: 0 !important; ">

            <div class="table-card invisible-scrollbar" style="overflow: scroll;">

                <table class="table align-middle table-nowrap">

                    <thead class="text-muted table-light">
                        <tr>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Document(s)</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Modified</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Type</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Status</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all">
                        <tr *ngFor="let myfileItem of model.myfileList.items; let index = index">
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 gap-2">
                                        <img src='{{getDocumentImageUrl(myfileItem)}}' alt=""
                                            class=" avatar-xs rounded-circle me-2">
                                    </div>
                                    {{myfileItem.name}}
                                </div>
                            </td>
                            <td>
                                {{dateRename(myfileItem.modifiedDate)}}
                            </td>
                            <td>
                                {{typeRename(myfileItem.type)}}
                            </td>
                            <td>
                                <span class="rounded" [ngClass]='statusTextClass(myfileItem.status)'>
                                    {{statusTextMyfile(myfileItem.status) | uppercase}}
                                </span>
                            </td>
                            <td>
                                <div class=" d-flex ">
                                    <ul class="list-inline hstack gap-2 mb-0">
                                        <div>
                                            <li><button [disabled]="submitted" class="dropdown-item"
                                                    href="javascript:void(0);" (click)="viewMyfile(myfileItem)">
                                                    <i class="ri-eye-fill align-bottom me-2 text-muted fs-17"
                                                        style="cursor: pointer;"></i>
                                                </button>
                                            </li>
                                        </div>
                                        <div
                                            *ngIf="myfileItem.status == enumDocumentStatus.New && index !=0 && (myfileItem.type == enumTemplateDocumentType.Invoice || myfileItem.type == enumTemplateDocumentType.Cheque  )">
                                            <li>
                                                <button
                                                    *ngIf="myfileItem.type == enumTemplateDocumentType.Invoice && securityPermissionRequisitionCreateInvoice else elseEditCheque"
                                                    [disabled]="submitted" class="dropdown-item"
                                                    href="javascript:void(0);" (click)="editMyfile(myfileItem)">
                                                    <i class="ri-edit-line align-bottom me-2 text-muted fs-20"
                                                        style="cursor: pointer;"></i>
                                                </button>
                                                <ng-template #elseEditCheque>
                                                    <button
                                                        *ngIf="myfileItem.type == enumTemplateDocumentType.Cheque  && securityPermissionRequisitionCreateCheque"
                                                        [disabled]="submitted" class="dropdown-item"
                                                        href="javascript:void(0);" (click)="editMyfile(myfileItem)">
                                                        <i class="ri-edit-line align-bottom me-2 text-muted fs-20"
                                                            style="cursor: pointer;"></i>
                                                    </button>
                                                </ng-template>

                                            </li>
                                        </div>
                                        <li class="list-inline-item">
                                            <div class="dropdown" ngbDropdown style="z-index: 100;  position: static;">
                                                <button class="btn btn-soft-secondary btn-sm dropdown arrow-none"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="ri-more-fill align-middle"></i>
                                                </button>
                                                <ul class="dropdown-menu " ngbDropdownMenu
                                                    style=" position: absolute; ">
                                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                                            (click)="viewMyfile(myfileItem)" style="cursor: pointer;">
                                                            <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                            View</a></li>
                                                    <li
                                                        *ngIf="securityPermissionRequisitionCreate && ( myfileItem.type == 3)">
                                                        <a class="dropdown-item" href="javascript:void(0);"
                                                            (click)="myfileRequestSignature(myfileItem.id)"
                                                            style="cursor: pointer;">
                                                            <i class="ri-draft-fill align-bottom me-2 text-muted"></i>
                                                            Request Signature</a>
                                                    </li>
                                                    <li><a class="dropdown-item edit-item-btn" data-bs-toggle="modal"
                                                            (click)="downloadMyfile(myfileItem.id)"
                                                            style="cursor: pointer;">
                                                            <i
                                                                class="ri-download-2-line align-bottom me-2 text-muted"></i>
                                                            Download</a></li>
                                                    <li
                                                        *ngIf="myfileItem.status == enumDocumentStatus.New && index !=0 && ( myfileItem.type == enumTemplateDocumentType.Invoice ||  myfileItem.type == enumTemplateDocumentType.Cheque )">
                                                        <a *ngIf=" myfileItem.type == enumTemplateDocumentType.Invoice && securityPermissionRequisitionCreateInvoice else elseEditCheque"
                                                            class="dropdown-item edit-item-btn" data-bs-toggle="modal"
                                                            (click)="editMyfile(myfileItem)" style="cursor: pointer;">
                                                            <i class="ri-edit-line align-bottom me-2 text-muted"></i>
                                                            Edit
                                                        </a>
                                                        <ng-template #elseEditCheque>
                                                            <a *ngIf=" myfileItem.type == enumTemplateDocumentType.Cheque && securityPermissionRequisitionCreateCheque"
                                                                class="dropdown-item edit-item-btn"
                                                                data-bs-toggle="modal" (click)="editMyfile(myfileItem)"
                                                                style="cursor: pointer;">
                                                                <i
                                                                    class="ri-edit-line align-bottom me-2 text-muted"></i>
                                                                Edit
                                                            </a>
                                                        </ng-template>
                                                    </li>

                                                    <li
                                                        *ngIf="securityPermissionRequisitionCreateCheque && myfileItem.status == enumDocumentStatus.Processed && myfileItem.type == enumTemplateDocumentType.Invoice">
                                                        <button [disabled]="submitted" class="dropdown-item"
                                                            href="javascript:void(0);" (click)="cheque(myfileItem.id)">
                                                            <i class="ri-bill-line align-bottom me-2 text-muted"
                                                                style="cursor: pointer;"></i> Create Cheque
                                                        </button>
                                                    </li>

                                                    <li
                                                        *ngIf="securityPermissionRequisitionCreatePayment && ((myfileItem.status == enumDocumentStatus.New && (requisition.requiresInvoiceApproval == undefined || requisition.requiresInvoiceApproval == false)) || myfileItem.status == enumDocumentStatus.Approved) && myfileItem.type == enumTemplateDocumentType.Invoice">
                                                        <button [disabled]="submitted" class="dropdown-item"
                                                            href="javascript:void(0);"
                                                            (click)="chargeInvoice(myfileItem)">
                                                            <i class="ri-exchange-dollar-line align-bottom me-2 text-muted"
                                                                style="cursor: pointer;"></i> Charge Invoice
                                                        </button>
                                                    </li>

                                                    <li
                                                        *ngIf="securityPermissionRequisitionCreatePayment && (myfileItem.status == enumDocumentStatus.New || myfileItem.status == enumDocumentStatus.PendingApproval) && myfileItem.type == enumTemplateDocumentType.Invoice">
                                                        <button [disabled]="submitted" class="dropdown-item"
                                                            href="javascript:void(0);" style="cursor: pointer;"
                                                            (click)="sendApprovalRequest(myfileItem)">
                                                            <i
                                                                class="ri-shield-check-line align-bottom me-2 text-muted  purple-color-only"></i>
                                                            Request Invoice Approval
                                                        </button>
                                                    </li>

                                                    <li
                                                        *ngIf="securityPermissionRequisitionRefundPayment  && myfileItem.status == enumDocumentStatus.Processed && myfileItem.type == enumTemplateDocumentType.Invoice">
                                                        <button [disabled]="submitted" class="dropdown-item"
                                                            href="javascript:void(0);"
                                                            (click)="refundInvoice(myfileItem)">
                                                            <i class="ri-exchange-dollar-line align-bottom me-2 text-muted"
                                                                style="cursor: pointer;"></i> Refund Invoice
                                                        </button>
                                                    </li>
                                                    <li
                                                        *ngIf="myfileItem.status == enumDocumentStatus.New && index !=0 && ( myfileItem.type == enumTemplateDocumentType.Invoice ||  myfileItem.type == enumTemplateDocumentType.Cheque )">
                                                        <a *ngIf=" myfileItem.type == enumTemplateDocumentType.Invoice && securityPermissionRequisitionDeleteInvoice else elseDeleteCheque"
                                                            class="dropdown-item remove-item-btn" data-bs-toggle="modal"
                                                            (click)="deleteMyfile(myfileItem.id,index)"
                                                            style="cursor: pointer;">
                                                            <i
                                                                class="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                            Delete
                                                        </a>
                                                        <ng-template #elseDeleteCheque>
                                                            <a *ngIf=" myfileItem.type == enumTemplateDocumentType.Cheque && securityPermissionRequisitionDeleteCheque"
                                                                class="dropdown-item remove-item-btn"
                                                                data-bs-toggle="modal"
                                                                (click)="deleteMyfile(myfileItem.id,index)"
                                                                style="cursor: pointer;">
                                                                <i
                                                                    class="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                                Delete
                                                            </a>
                                                        </ng-template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
            <div *ngIf="myFileListService.totalRecords > 9" class="row justify-content-md-between align-items-md-center"
                style="padding-top: 1rem;">
                <div class="col col-sm-6">
                    <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                        {{pagingInfoMyfiles}}
                    </div>
                </div>
                <div class="col col-sm-6">
                    <div class="text-sm-right float-end listjs-pagination">

                        <ngb-pagination [collectionSize]="(myfileTotal | async)!"
                            [(page)]="myFileListService.startIndex">
                            <ng-template ngbPaginationPages let-page let-pages="pages">
                                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                    <div class="mb-4 d-flex flex-nowrap px-2">
                                        <label id="paginationInputLabel" for="paginationInput"
                                            class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                        <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                            class="form-control custom-pages-input" id="paginationInput"
                                            [value]="myFileListService.startIndex"
                                            (keyup.enter)="selectPageMyfiles(i.value)"
                                            (blur)="selectPageMyfiles(i.value)"
                                            (input)="formatInputMyfiles($any($event).target)"
                                            aria-labelledby="paginationInputLabel paginationDescription"
                                            style="text-align: center; width:3.5rem;" />
                                        <span id="paginationDescription" class="col-form-label text-nowrap px-2 ">
                                            <span i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                    </div>
                                </li>
                            </ng-template>
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>

    </div>

</ng-template>